import Base from 'app/models/base';

export default Base.extend({
  initialize({ choices, paramKey, staticKey, initialIdx }) {
    this.choices = choices;
    this.paramKey = paramKey;
    this.staticKey = staticKey;
    this.set('currentChoice', initialIdx ? this.choices[initialIdx] : this.choices[0]);
  },

  getVal() {
    return this.get('currentChoice').option;
  },

  getParams() {
    const val = this.getVal();
    return val ? { [this.paramKey]: val, ...this.staticKey } : {};
  },
});



// WEBPACK FOOTER //
// ./app/models/dropdown_selection.js